module.exports = __webpack_public_path__ + "media/components/country-flag/static/mr-b16300c7ee4750c55de60cc6520c71b7.svg";